import ReadyToLaunchPreview from "../../images/ready-to-launch-preview.png"
import customBuildPathPreview from "../../images/custom-build-path-preview.png"
import {OrgBankingSetupState} from "../../services/orgBankingSetup"

export type BuildPathType = Exclude<OrgBankingSetupState, "NotSet">

export interface BuildPathOption {
	image: string
	title: string
	subtitle: string
	features: string[]
}

export const buildPathOptions: Record<BuildPathType, BuildPathOption> = {
	ReadyToLaunchBanking: {
		image: ReadyToLaunchPreview,
		title: "Ready to Launch",
		subtitle: "Teams prioritizing speed to market with minimal investment.",
		features: [
			"No-code setup in 1 day",
			"Go live in as little as 2 weeks",
			"Pre-built feature set optimized for quick deployment",
			"White-labeled and embedded experience",
		],
	},
	Custom: {
		image: customBuildPathPreview,
		title: "Custom",
		subtitle: "Teams building customized experiences with dedicated engineering resources.",
		features: [
			"Fully customizable design and workflows",
			"Complete API and data access",
			"Tailored programs with longer ramp-up (3–6 months)",
			"Maximum control and growth potential",
		],
	},
}

export function isBuildPathType(setup: OrgBankingSetupState | undefined): setup is BuildPathType {
	return setup !== "NotSet"
}
